import { useState, type FormEvent } from 'react';
import { ApiError, login as signIn, type Me } from '../api.js';

/**
 * Экран входа.
 *
 * Отдельные сообщения на «неверный пароль» и «доступ не выдан» — не мелочь:
 * человек с верным паролем, но без доступа, иначе будет искать ошибку в пароле
 * и переберёт достаточно вариантов, чтобы заблокировать корпоративную учётку.
 */
export function Login({ onSuccess }: { onSuccess: (me: Me) => void }) {
  const [loginValue, setLoginValue] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);

    signIn(loginValue, password).then(
      (me) => onSuccess(me),
      (cause: unknown) => {
        setError(cause instanceof ApiError ? cause.message : 'Не удалось войти');
        setBusy(false);
        setPassword('');
      },
    );
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <h1>Cost sharing</h1>
        <p className="muted small">Часы Jira, ревизия и сверка с PeopleForce</p>

        <label className="login-field">
          Логин
          <input
            type="text"
            autoComplete="username"
            autoFocus
            value={loginValue}
            onChange={(event) => setLoginValue(event.target.value)}
            required
          />
        </label>

        <label className="login-field">
          Пароль
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>

        {error && <div className="login-error">{error}</div>}

        <button type="submit" className="login-button" disabled={busy}>
          {busy ? 'Проверяю…' : 'Войти'}
        </button>

        {/* Пароль корпоративный, и сказать об этом надо до того, как человек
            начнёт подбирать: несколько неверных попыток блокируют учётку
            целиком — вместе с почтой и Jira. */}
        <p className="muted small login-note">
          Логин и пароль — корпоративные. Доступ выдаётся отдельно: если пароль верный, а система
          пишет «доступ не выдан», обратитесь к администратору.
        </p>
      </form>
    </div>
  );
}
